import React, { Component } from 'react';

import { withTranslation } from 'react-i18next'
import Moment from 'react-moment';
import MatrikkelSearchEvents from '../MatrikkelSearchEvents.js'
import VisIcon from '../../../images/submenu_open copy 6.png'
import NavigateIcon from '../../../images/submenu_open copy 5.png'
import CollapseIcon from '../../../images/collapse copy 5.png'
import ExpandIcon from '../../../images/expand copy 5.png'
import WarningIcon from '../../../images/advarsel2.png'


class Matrikkelenhet extends Component {
    state = {
        isOpened: false
    }

    toggleMatrikkelenhet = () => {
        this.setState({isOpened: !this.state.isOpened})
    }

    navigateMatrikkelenhet = (event) => {
        event.stopPropagation()
        this.props.onMatrikkelObjectSelected({
            domainKlasse: "Matrikkelenhet",
            matrikkelenhet: this.props.matrikkelenhet
        })
    }

    showMatrikkelenhet = (event) => {
        event.stopPropagation()
        this.props.onEvent({
            type: MatrikkelSearchEvents.ShowObject,
            data: {
                type: MatrikkelSearchEvents.ShowMatrikkelenhet,
                matrikkelenhet: this.props.matrikkelenhet
            }
        })
    }

    render() {
        const { t } = this.props
        var matrikkelenhet = this.props.matrikkelenhet
        var matrikkelnummer = `${matrikkelenhet.gardsnummer}/${matrikkelenhet.bruksnummer}`;
        if (matrikkelenhet.festenummer || matrikkelenhet.seksjonsnummer) matrikkelnummer += `/${matrikkelenhet.festenummer}/${matrikkelenhet.seksjonsnummer}`;
        var infoList = []
        if (matrikkelenhet.utgatt) infoList.push(t('utgatt'))
        if (!matrikkelenhet.harTeig) infoList.push(t('manglerteig'))
        var arealmerknader = matrikkelenhet.arealmerknader ? matrikkelenhet.arealmerknader.map(a => a.arealmerknad).join(', ') : '';

        return (
            <li>
                <div className="section-header subsection" onClick={this.toggleMatrikkelenhet}>
                    <span className={`icon sublevel ${this.props.isLast ? 'sublevel-end' : ''}`}></span>
                    <span className="title">{matrikkelenhet.domeneklasse} - {matrikkelenhet.kommuneId} - {matrikkelnummer}</span>
                    { infoList.length > 0 &&
                    <div className="icon-image tooltip warning">
                        <img src={WarningIcon} />
                        <div className="tooltip-content">
                            {infoList.map((i, index) => { return (<div key={index}>{i}</div>) })}
                        </div>
                    </div> }
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                    <div className="icon-image right tooltip" onClick={this.navigateMatrikkelenhet}>
                        <img className="tool" src={NavigateIcon} />
                        <div className="tooltip-content">{t('naviger.matrikkelenhet', { domeneklasse: matrikkelenhet.domeneklasse.toLowerCase() })}</div>
                    </div>
                    { matrikkelenhet.harTeig &&
                    <div className="icon-image right tooltip" onClick={this.showMatrikkelenhet}>
                        <img className="tool" src={VisIcon} />
                        <div className="tooltip-content">{t('vis.matrikkelenhet', { domeneklasse: matrikkelenhet.domeneklasse.toLowerCase() })}</div>
                    </div> }
                </div>
                <div className={`section-content${this.state.isOpened ? '' : ' collapsed'}`}>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('kommune')}</div>
                            <div className="value">{matrikkelenhet.kommunenavn}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('eiendomstype')}</div>
                            <div className="value">{matrikkelenhet.domeneklasse}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('eiendom')}</div>
                            <div className="value">{matrikkelnummer}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('bruksnavn')}</div>
                            <div className="value">{matrikkelenhet.bruksnavn}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('etablertdato')}</div>
                            <div className="value"><Moment local>{matrikkelenhet.etableringsdato}</Moment></div>
                        </div>
                        <div className="column">
                            <div className="label">{t('oppdatertdato')}</div>
                            <div className="value"><Moment local parse="YYYY-MM-DDTHH:mm:ss">{matrikkelenhet.oppdateringsdato}</Moment></div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('historiskoppgittareal')}</div>
                            <div className="value">{matrikkelenhet.historiskOppgittAreal}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('historiskarealkilde')}</div>
                            <div className="value">{matrikkelenhet.historiskArealkilde}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('beregnetareal')}</div>
                            <div className="value">{matrikkelenhet.areal}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('arealberegnetmedalleteiger')}</div>
                            <div className="value">{matrikkelenhet.arealBeregnetMedAlleTeiger ? "Ja" : "Nei"}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('tinglyst')}</div>
                            <div className="value">{matrikkelenhet.tinglyst ? "Ja" : "Nei"}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('undersammenslaingbestar')}</div>
                            <div className="value">{matrikkelenhet.underSammenslaingBestar ? "Ja" : "Nei"}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('undersammenslaingutgar')}</div>
                            <div className="value">{matrikkelenhet.underSammenslaingUtgar ? "Ja" : "Nei"}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('nymatrikulert')}</div>
                            <div className="value">{matrikkelenhet.nymatrikulert ? "Ja" : "Nei"}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('harfester')}</div>
                            <div className="value">{matrikkelenhet.harAktiveFestegrunner ? "Ja" : "Nei"}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('seksjonert')}</div>
                            <div className="value">{matrikkelenhet.erSeksjonert ? "Ja" : "Nei"}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('ikkefullfortoppmalingsforretning')}</div>
                            <div className="value">{matrikkelenhet.oppmalingIkkeFullfort}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('fristfullforing')}</div>
                            <div className="value"><Moment local>{matrikkelenhet.fristOppmaling}</Moment></div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('mangelvedoppmalingskravet')}</div>
                            <div className="value">{matrikkelenhet.mangelMatrikkelforingskrav}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('fristretting')}</div>
                            <div className="value"><Moment local>{matrikkelenhet.fristMatrikkelforingskrav}</Moment></div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('skyld')}</div>
                            <div className="value">{matrikkelenhet.skyld}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('punktfeste')}</div>
                            <div className="value">{matrikkelenhet.harPunktfeste ? "Ja" : "Nei"}</div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="column">
                            <div className="label">{t('utgatt')}</div>
                            <div className="value">{matrikkelenhet.utgatt ? "Ja" : "Nei"}</div>
                        </div>
                        <div className="column">
                            <div className="label">{t('arealmerknader')}</div>
                            <div className="value">{arealmerknader}</div>
                        </div>
                    </div>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(Matrikkelenhet)